import {Component, inject, OnInit, OnDestroy} from '@angular/core'
import {Router, RouterOutlet} from '@angular/router'
import {TitleService} from './services/title.service'
import {ThemeService} from './services/theme.service'
import {NgxSpinnerComponent} from "ngx-spinner";
import {fromEvent, merge, Observable, Observer, Subscription} from "rxjs";
import {map} from 'rxjs/operators';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, NgxSpinnerComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'

})
export class AppComponent implements OnInit, OnDestroy {
    title = 'Quebills'
    private titleService = inject(TitleService);
    private themeService = inject(ThemeService);
    offlineSubscription: Subscription;

    constructor(private router: Router) {
    }

    ngOnInit(): void {
        this.themeService.initTheme();
        this.titleService.init();
        this.offlineSubscription = this.createOnline$().subscribe(isOnline => {
            if (!isOnline) {
                this.router.navigate(['no-network']);
            }
        });
    }

    createOnline$(): Observable<boolean> {
        return merge(
            fromEvent(window, 'offline').pipe(map(() => false)),
            fromEvent(window, 'online').pipe(map(() => true)),
            new Observable<boolean>((sub: Observer<boolean>) => {
                sub.next(navigator.onLine);
                sub.complete();
            })
        );
    }

    ngOnDestroy(): void {
        this.offlineSubscription.unsubscribe();
    }

}
